import * as yup from 'yup';

export const validateEmails = (emails) => {
  if (!emails) return [];
  
  const invalidEmails = emails.filter((email) => !isValidEmail(email));
  return invalidEmails;
};

export const isValidEmail = (email) => {
  const emailSchema = yup.string().email();
  return emailSchema.isValidSync(email);
};